<template>
  <section
    v-if="blok && blok.length"
    v-editable="blok"
    class="hero-banner-slider overflow-x-hidden"
  >
    <NuxtLazyHydrate :when-idle="3000">
      <UniversalCarousel
        :max-items-per-slide="1"
        :max-items-per-slide-mobile="1"
        :autoplay-speed="5000"
        :item-count="blok.length"
      >
        <SwiperSlide v-for="(banner, idx) in blok" :key="banner._uid">
          <HeroBanner
            class="hero-banner"
            :lazy="idx > 0"
            :blok="banner"
            :index="String(idx)"
            @load="$emit('load')"
          />
        </SwiperSlide>
      </UniversalCarousel>
    </NuxtLazyHydrate>
  </section>
</template>

<script setup lang="ts">
import type { SbHeroBanner } from '~/cms/storyblok/types/storyblok.gen'

type HeroBannerSliderProps = {
  blok?: SbHeroBanner[]
}

withDefaults(defineProps<HeroBannerSliderProps>(), { blok: () => [] })

defineEmits<{ load: [] }>()
</script>

<style lang="scss" scoped>
.hero-banner-slider {
  &,
  .swiper,
  .swiper-wrapper,
  .swiper-slide,
  .hero-banner {
    height: 100% !important;
  }
}
</style>
